import { render, staticRenderFns } from "./CLayoutEditorHeader.vue?vue&type=template&id=71126909"
import script from "./CLayoutEditorHeader.vue?vue&type=script&lang=js"
export * from "./CLayoutEditorHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports